import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import OfflineInvestor from 'src/entities/OfflineInvestor';

export interface ApiOfflineInvestorResponse {
  id: number;
  name: string;
  amountInvested: number;
  investmentType: string;
}

interface ApiOfflineInvestorCreateRequest {
}

export class OfflineInvestorFactory extends BaseFactory<OfflineInvestor> {
  public toEntity(args: ApiOfflineInvestorResponse): OfflineInvestor {
    return new OfflineInvestor({
      id: args.id,
      name: args.name,
      amountInvested: args.amountInvested,
      investmentType: args.investmentType,
    });
  }

  public toRequest(offlineInvestor: OfflineInvestor): ApiOfflineInvestorCreateRequest {
    return offlineInvestor;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/OfflineInvestorFactory.tsx